import { AssumptionImpact } from "../../types";
export const assumptionImpact: { [key in AssumptionImpact]: string } = {
  HIGH: "Alto",
  MEDIUM: "Medio",
  LOW: "Bajo"
};
